<div class="container-fluid pt-2">
  <!-- Tester Tools master switch (non-production, System Administrators only): an opt-in layer that
       reveals the tester tooling (Section 1 auto-populate; later phases add Tester Approve and
       auto-advance). Off by default; resets on a full page reload. -->
  <div
    class="d-flex justify-content-end align-items-center d-print-none"
    *ngIf="showTesterToggle"
  >
    <mat-slide-toggle
      color="warn"
      [checked]="testerToolsEnabled"
      (change)="setTesterToolsEnabled($event.checked)"
      matTooltip="Non-production tester tools: auto-populate, Tester Approve, and auto-advance. Off by default."
      matTooltipPosition="left"
    >
      Tester Tools
    </mat-slide-toggle>
  </div>
  <!-- Tester tool (non-production, System Administrators only): auto-advance the form to a chosen
       status by applying all required signatures server-side in a single request. Options are
       filtered to this form's path (Shielding Inspections / PPS Testing only when applicable) and
       grey out once the form has reached (or passed) that status. -->
  <div class="d-flex justify-content-end mb-2 d-print-none" *ngIf="showAutoAdvance">
    <button
      mat-stroked-button
      color="warn"
      type="button"
      [matMenuTriggerFor]="autoAdvanceMenu"
      [disabled]="advancing"
      matTooltip="Tester tool (non-production): applies all required signatures, as the appropriate users, to advance the form to the selected status."
      matTooltipPosition="left"
    >
      <mat-icon>fast_forward</mat-icon>
      {{ advancing ? 'Advancing...' : 'Auto-advance to...' }}
    </button>
    <mat-menu #autoAdvanceMenu="matMenu">
      <button
        mat-menu-item
        type="button"
        *ngFor="let t of advanceTargets; trackBy: trackByAdvanceTarget"
        [disabled]="!canAdvanceTo(t)"
        (click)="autoAdvance(t)"
      >
        {{ t.label }}
      </button>
    </mat-menu>
  </div>
  <rsf-main-s1
    [rsf]="rsf"
    [rsfAmendment]="rsfAmendment"
    [disabled]="disabled"
    [status]="status"
    [privileges]="privileges"
    [service]="service"
    (formValidChanged)="formValidChange($event)"
    (systemsAffectedChanged)="systemsAffectedChange($event)"
  ></rsf-main-s1>
  <div [ngClass]="{ invisible: !rsf || rsf.status == formStatusEnum.New }">
    <!-- Approvals -->
    <rsf-main-s2
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [status]="status"
      [privileges]="privileges"
      [service]="service"
    ></rsf-main-s2>

    <worker-verification-table
      [currentDocument]="rsf"
      [privilegeToSign]="privilegeEnum.RSFWorker"
      [status]="status"
      [signPrivilegeName]="'RSF Worker'"
    ></worker-verification-table>

    <!-- No Work Performed -->
    <rsf-main-s3
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [status]="status"
      [privileges]="privileges"
      [service]="service"
    ></rsf-main-s3>

    <!-- Holdpoints -->
    <rsf-main-s4
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [status]="status"
      [privileges]="privileges"
      [service]="service"
    ></rsf-main-s4>

    <!-- Close Out -->
    <rsf-main-s5
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [status]="status"
      [privileges]="privileges"
      [service]="service"
    ></rsf-main-s5>

    <!-- Operational Approvals -->
    <rsf-main-s6
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [status]="status"
      [privileges]="privileges"
      [service]="service"
    ></rsf-main-s6>

    <!-- Comments -->
    <comments-and-attachments
      [currentDocument]="rsf"
      headerClass="h5 mt-3"
    ></comments-and-attachments>
  </div>
</div>
<rsf-main-buttons
  *ngIf="rsf"
  [rsf]="rsf"
  [rsfAmendment]="rsfAmendment"
  [privileges]="privileges"
  [status]="status"
  [formValid]="formValid"
  [amendmentChangesSaved]="amendmentChangesSaved"
  [amendmentHasChanges]="hasAmendmentChanges()"
  (buttonAction)="buttonClicked($event)"
  [service]="service"
></rsf-main-buttons>
